import React from 'react';
import { AlertCircle, Clock } from 'lucide-react';

interface UrgencyBannerProps {
  message: string;
  type?: 'info' | 'warning' | 'success';
  icon?: 'clock' | 'alert';
  className?: string;
}

const UrgencyBanner: React.FC<UrgencyBannerProps> = ({
  message,
  type = 'info',
  icon = 'clock',
  className = ''
}) => {
  const bgColors = {
    info: 'bg-blue-500/10 border-blue-500/20',
    warning: 'bg-orange-500/10 border-orange-500/20',
    success: 'bg-green-500/10 border-green-500/20'
  };
  
  const textColors = {
    info: 'text-blue-700',
    warning: 'text-orange-700',
    success: 'text-green-700'
  };
  
  const Icon = icon === 'clock' ? Clock : AlertCircle;
  
  return (
    <div className={`${bgColors[type]} border rounded-lg p-4 ${className}`}>
      <div className="flex items-center justify-center gap-3">
        <Icon className={`w-5 h-5 ${textColors[type]}`} />
        <p className={`text-sm md:text-base font-semibold ${textColors[type]}`}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default UrgencyBanner;
